/* eslint-disable spire/export-styles */
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getCartState,
    getCurrentCartState,
    hasProductsWithInvalidPrice,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import React, { FC, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { css } from "styled-components";
import getColor from "@insite/mobius/utilities/getColor";

interface OwnProps {}

export interface PlaceOrderButtonStyles {
    button?: ButtonPresentationProps;
}

const placeOrderButtonStyles: PlaceOrderButtonStyles = {
    button: {
        css: css`
            width: 100%;
            text-align: center;
            padding: 20px 0;
            cursor: pointer;
            transition: 0.2s ease;
            margin-top: auto;
            border-radius: 0;
            background: #fff;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;
            :disabled {
                // background: #fff !important;
                cursor: not-allowed;
                color: ${getColor("primary")};
            }
            span {
                color: ${getColor("primary")};
            }
            :hover {
                background-color: ${getColor("primary")};
                span {
                    color: #fff;
                }
            }

            img {
                width: 40px;
            }
        `,
    },
};

const mapStateToProps = (state: CustomApplicationState) => {
    const { cartId, isPlacingOrder, isCheckingOutWithPayPay } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId && cartId != undefined ? getCartState(state, cartId) : getCurrentCartState(state);
    const isDealerCertificateRequired = cartState?.value?.cartLines?.some(cartLine => {
        return cartLine.properties.showAuthorizationRequired?.toLowerCase() === "true";
    });
    return {
        isDisabled:
            cartState.isLoading ||
            !cartState?.value?.orderSubTotalDisplay ||
            isPlacingOrder ||
            isCheckingOutWithPayPay ||
            (cartState.value?.type !== "Quote" && hasProductsWithInvalidPrice(cartState.value)) ||
            cartState.value?.hasInsufficientInventory === true ||
            state.ADIGlobalData.ADIUpdateCartLoading.loading ||
            isDealerCertificateRequired,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CheckoutReviewAndSubmitPlaceOrderButton: FC<Props> = ({ isDisabled }) => {
    const [showCustomerStatusBanner, setShowCustomerStatusBanner] = useState<boolean>();
    const [allowOrderPlacement, setAllowOrderPlacement] = useState<boolean>();

    const handleClick = () => {
        document.getElementById("reviewAndSubmitPaymentForm-submit")?.click();
        localStorage.setItem("placeorder_clicked", "true");
    };
    const getCustomerCreditStatus = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
    );

    // The below function is because of P21 Change
    function getStatusCall() {
        const showCustomerStatusBanner = getCustomerCreditStatus?.getcustomerStatus.showCustomerStatusBanner;
        const allowOrderPlacementResponse = getCustomerCreditStatus?.getcustomerStatus?.allowOrderPlacement;
        const allowWebPaymentsResponse = getCustomerCreditStatus?.getcustomerStatus?.allowWebPayments;
        const allowCheckoutFlag = allowOrderPlacementResponse === "Y" ? true : false;
        setShowCustomerStatusBanner(showCustomerStatusBanner);
        setAllowOrderPlacement(allowCheckoutFlag);
        localStorage.setItem("showCustomerStatusBanner", showCustomerStatusBanner);
    }

    useEffect(() => {
        getStatusCall();
    }, [
        getCustomerCreditStatus?.getcustomerStatus.showCustomerStatusBanner,
        allowOrderPlacement,
        showCustomerStatusBanner,
        getCustomerCreditStatus?.getcustomerStatus?.allowOrderPlacement,
    ]);
    return (
        <Button
            type="submit"
            disabled={!allowOrderPlacement || isDisabled} // allowOrderPlacement: This condition is being used by P21 ---- P21 Change
            data-test-selector="checkoutReviewAndSubmit_placeOrder"
            {...placeOrderButtonStyles.button}
            onClick={handleClick}
            style={{ display: isDisabled || !allowOrderPlacement ? "none" : "block" }}
        >
            {/* {isDisabled ? (
                <img src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/rd-addtocart-loader.gif" />
            ) : (
                translate("Place Order")
            )} */}
            {translate("Place Order")}
        </Button>
    );
};

export default connect(mapStateToProps)(CheckoutReviewAndSubmitPlaceOrderButton);
